import React, { useEffect, useState } from "react";
import { Divider, useMediaQuery } from "@mui/material";
import { FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import { useLocation, useParams } from "react-router-dom";
import { s3baseUri } from "../../config/config";
import { useIds } from "../../hook/AdminContext";
import { show_proper_words } from "../../utils/Constant";
import { get_client_detail_for_sectors } from "../../DAL/partner/partners";
import { useSnackbar } from "notistack";
import PageLoading from "../../components/loader/PageLoading";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";

export default function PartnerDetail() {
  const { enqueueSnackbar } = useSnackbar();
  const { category_id, detail_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState({});
  const { setBreadCrumb } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const isMobile = useMediaQuery("(max-width:600px)");

  const fetchCategories = async () => {
    const response = await get_client_detail_for_sectors(detail_id);
    console.log(detail_id, "detail_iddetail_id");
    if (response.code === 200) {
      setCategories(response?.organization);
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },

      {
        name: `Agency Partners`,
        path: `/${firstSegment}/partners`,
        active: false,
      },
      {
        name: `Partner Detail`,
        path: ``,
        active: true,
      },
    ]);
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="heading-main">
            <h2 className="ms-0">Partner Detail</h2>
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="card shadow-md p-4 card-padding">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="d-flex">
                  <div className=" heading-main container  mb-4 ">
                    <h2>{categories?.name}</h2>
                  </div>
                </div>
                <hr />
                <div
                  className="info-section detail-page-text"
                  style={{
                    wordWrap: "break-word",
                    overflow: "hidden",
                    maxWidth: "100%",
                  }}
                >
                  <p>
                    <strong>Company Name</strong>{" "}
                    <span className="text-muted ms-4">
                      {categories?.company_name || "N/A"}
                    </span>
                  </p>
                  <Divider />
                  <div
                    className="d-flex flex-wrap"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* <strong className="ms-3">Sector</strong>
                    <p className="text-muted">{categories?.sector || "N/A"}</p> */}
                  </div>

                  {/* <Divider /> */}

                  <p>
                    <strong>Location</strong>{" "}
                    <span className="text-muted">
                      {categories?.location || "N/A"}
                    </span>
                  </p>
                  <Divider />
                  {/* <p>
                      <strong>Established in</strong>{" "}
                      <span className="text-muted">
                        {categories?.established_in || "N/A"}
                      </span>
                    </p>
                    <Divider /> */}
                  <p>
                    <strong>Website</strong>{" "}
                    {categories?.website ? (
                      <a
                        href={categories.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary ms-4 pointer"
                        style={{
                          wordBreak: "break-word",
                          marginLeft: isMobile ? "10px" : "",
                        }}
                      >
                        {categories?.website}
                      </a>
                    ) : (
                      <span>no data</span>
                    )}
                  </p>
                  <Divider />

                  <p>
                    <strong>Contact Number</strong>{" "}
                    <span className="text-muted ms-4">
                      {categories?.contact_number || "N/A"}
                    </span>
                  </p>
                  <Divider />
                  <p>
                    <strong>Email</strong>{" "}
                    <span className="text-muted ms-4">
                      {categories?.user_id?.email || "N/A"}
                    </span>
                  </p>
                  <Divider />
                </div>
                <div
                  className="d-flex gap-4 mt-3 anchor-tag"
                  style={{ justifyContent: "end" }}
                >
                  {categories?.social_links?.facebook && (
                    <a
                      href={categories?.social_links?.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook size={25} />
                    </a>
                  )}
                  {categories?.social_links?.instagram && (
                    <a
                      href={categories?.social_links?.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram size={25} />
                    </a>
                  )}
                  {categories?.social_links?.linkedin && (
                    <a
                      href={categories?.social_links?.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin size={25} />
                    </a>
                  )}
                  {categories?.social_links?.twitter && (
                    <a
                      href={categories?.social_links?.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitter size={25} />
                    </a>
                  )}
                  {categories?.social_links?.youtube && (
                    <a
                      href={categories?.social_links?.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube size={25} />
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
                {categories.profile_image ? (
                  <img
                    src={s3baseUri + categories.profile_image}
                    alt={categories.company_name + " Logo"}
                    className="rounded-3 shadow-sm img-fluid"
                  />
                ) : (
                  <RecordNoImage title={categories?.company_name + " Logo"} />
                )}
              </div>
            </div>
          </div>
          {categories.about && (
            <div className="card shadow-md p-4 mt-3 mb-4 about-content">
              <h4 className="fw-bold mb-4  ps-2  ">About</h4>
              <p
                className="ps-2 ckeditor"
                dangerouslySetInnerHTML={{ __html: categories.about }}
              ></p>{" "}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
